export default __webpack_public_path__ + "static/media/goldman-logo-purple.2cce4de5.svg";